import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { EventMessage, InteractionStatus } from '@azure/msal-browser';
import { PrimeNGConfig } from 'primeng/api';
import { Subject, Subscription, catchError, filter, fromEvent, map, merge, of, takeUntil, throwError } from 'rxjs';
import { UserAdService } from './main/service/user-ad.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    networkStatus: boolean = false;
    networkStatus$: Subscription = Subscription.EMPTY;

    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();

    private unsubscriber: Subject<void> = new Subject<void>();

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private _userAd: UserAdService,
        private _router: Router,
        private primengConfig: PrimeNGConfig) {
        this.isIframe = window !== window.parent && !window.opener;
        this.authService.instance.enableAccountStorageEvents();
        this.msalBroadcastService.msalSubject$
            .subscribe((result: EventMessage) => {
                if (this.authService.instance.getAllAccounts().length === 0) {
                } else {
                    this.setLoginDisplay();
                }
            }
            );
        this.msalBroadcastService.inProgress$
            .pipe(
                filter(
                    (status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe((userAD) => {
                this.setLoginDisplay();
                this.checkAndSetActiveAccount();
            });
    }

    ngOnInit(): void {
        this._userAd.UserLoggedIn()
            .pipe(
                catchError(err => {
                    console.log(err)
                    return throwError(() => err);
                })
            )
            .subscribe(
                {
                    next: (_connectedUser: any) => {
                        if (_connectedUser) {
                            
                            this._userAd.setUser(_connectedUser);
                            let userGroupsStringCollections: string[] = [];
                            _connectedUser.userGroups?.map(
                                (_: any) => {
                                    if (_) {
                                        userGroupsStringCollections.unshift(_.displayName);
                                    }
                                }
                            );
                        }
                    }
                }
            );
        this.checkNetworkStatus();

        history.pushState(null, '');

        fromEvent(window, 'popstate').pipe(
            takeUntil(this.unsubscriber)
        ).subscribe((_) => {
            history.pushState(null, '');
        });
        this.primengConfig.ripple = true;
    }

    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    }

    checkAndSetActiveAccount() {
        let activeAccount = this.authService.instance.getActiveAccount();
        if (this.authService.instance.getAllAccounts().length > 0) {
            let accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
        } else {
            this._router.navigateByUrl('/');
        }
    }

    checkNetworkStatus() {

        this.networkStatus = navigator.onLine;
        this.networkStatus$ = merge(
            of(null),
            fromEvent(window, 'online'),
            fromEvent(window, 'offline')
        )
            .pipe(map(() => navigator.onLine))
            .subscribe(status => {
                this.networkStatus = status;
                if (!status) {
                    this._router.navigateByUrl('/offline-exception');
                }
            });
    }

}
